document.addEventListener("DOMContentLoaded", function() {
  const isCustomizer = window.self !== window.top || window.location.search.includes('preview_theme_id');
  if (isCustomizer) return;

  const urlParams = new URLSearchParams(window.location.search);
  const redirected = urlParams.get('redirected');

  if (redirected === 'true' || sessionStorage.getItem('hasBeenRedirected') === 'true') {
    return;
  }

  fetch('https://ipapi.co/country_code/')
    .then(response => response.text())
    .then(countryCode => {
      console.log("Detected Country Code:", countryCode);

      if (countryCode !== 'PL') {
        sessionStorage.setItem('hasBeenRedirected', 'true');
        const popupOverlay = document.getElementById('market-language-popup');
        if (popupOverlay) {
          popupOverlay.style.display = 'flex';
        } else {
          console.error("Pop-up snippet not found in the DOM.");
        }
      } else {
        sessionStorage.setItem('hasBeenRedirected', 'true');
        console.log("User is from Lithuania; pop-up will not be displayed.");
      }
    })
    .catch(error => console.log('Error fetching country code:', error));
});
